// extracted by mini-css-extract-plugin
module.exports = {"anchor":"_1MMsjoll53f64xKKGJuTHB","icon":"_17O7gJQ-UcglXKq03GlaSF"};